import { createContext, useContext } from "react";
import type { NodesEdgesContextType } from "@app/services/aiFlow.types";

export const NodesEdgesContext = createContext<
  NodesEdgesContextType | undefined
>(undefined);

export const useNodesEdges = () => {
  const context = useContext(NodesEdgesContext);
  if (!context) {
    throw new Error("useNodesEdges must be used within a NodesEdgesProvider");
  }
  return context;
};
